import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

// Song readiness (request list curation spec §3.1). Only gig-ready songs are offered to the
// audience by default; rusty ones only when a gig is set to Relaxed; not-ready ones never.
export const READINESS = {
  ready:     { label: 'Gig-ready', emoji: '✅', color: '#1f8a4c' },
  rusty:     { label: 'Rusty',     emoji: '🟡', color: '#b7791f' },
  not_ready: { label: 'Not ready', emoji: '🔴', color: '#c53030' },
};
export const READINESS_KEYS = ['ready', 'rusty', 'not_ready'];

const DAY = 24 * 60 * 60 * 1000;
export const RUSTY_AFTER_DAYS = 90;
export const REAUDIT_AFTER_DAYS = 182;  // about 6 months

export const setReadiness = (songIds, readiness) =>
  axios.patch(`${API_URL}/api/songs/readiness`, { song_ids: songIds, readiness });

export const dismissReadinessHint = (songId) =>
  axios.patch(`${API_URL}/api/songs/${songId}/readiness-hint`);

// last_played arrives as 'YYYY-MM-DD'; read it as a local date
const parseDay = (d) => (d ? new Date(`${String(d).slice(0, 10)}T00:00:00`) : null);

export const formatDay = (d) => {
  const day = parseDay(d);
  if (!day) return '';
  const sameYear = day.getFullYear() === new Date().getFullYear();
  return day.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', ...(sameYear ? {} : { year: 'numeric' }) });
};

// A suggestion for one song, never applied automatically:
//  - 'rusty':  gig-ready but not played for 90 days ("mark as Rusty?"). Songs never played
//              don't get it, or a new library would flag almost every song on day one.
//  - 'ready':  rusty, but played since it was marked rusty ("back to Gig-ready?")
// A dismissal holds until the song is played again.
export function readinessHint(song, now = Date.now()) {
  const played = parseDay(song.last_played);
  if (!song.is_active || !played) return null;
  const dismissed = song.readiness_hint_dismissed_at ? new Date(song.readiness_hint_dismissed_at).getTime() : 0;
  const staleFrom = played.getTime() + RUSTY_AFTER_DAYS * DAY;

  if (song.readiness === 'ready' && now >= staleFrom && dismissed < staleFrom) {
    return { suggest: 'rusty', text: `Not played since ${formatDay(song.last_played)}: mark as Rusty?` };
  }
  const reviewed = song.readiness_reviewed_at ? new Date(song.readiness_reviewed_at).getTime() : 0;
  if (song.readiness === 'rusty' && played.getTime() > reviewed && dismissed < played.getTime()) {
    return { suggest: 'ready', text: `Played on ${formatDay(song.last_played)}: back to Gig-ready?` };
  }
  return null;
}

// Songs due a look in a re-audit: never reviewed, or not for about 6 months
export const dueForReview = (song, now = Date.now()) =>
  song.is_active && (!song.readiness_reviewed_at || now - new Date(song.readiness_reviewed_at).getTime() >= REAUDIT_AFTER_DAYS * DAY);
